// contexts/CartContext.js - Fixed with Variant Images
import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    try {
      const saved = localStorage.getItem('sugandhi_cart');
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem('sugandhi_cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product) => {
    setCart(prev => {
      // Create a unique key for variant differentiation
      const itemKey = product.variantId && product.variantId !== 'standard'
        ? `${product.id}_${product.variantId}` 
        : `${product.id}_standard`;
      
      const existing = prev.find(item => {
        const existingKey = item.variantId && item.variantId !== 'standard'
          ? `${item.id}_${item.variantId}` 
          : `${item.id}_standard`;
        return existingKey === itemKey;
      });
      
      if (existing) {
        // If same variant exists, increase quantity
        return prev.map(item => {
          const itemExistingKey = item.variantId && item.variantId !== 'standard'
            ? `${item.id}_${item.variantId}` 
            : `${item.id}_standard`;
          return itemExistingKey === itemKey 
            ? { ...item, quantity: item.quantity + (product.quantity || 1) } 
            : item;
        });
      }
      
      // Add new item with variant info and proper image
      return [...prev, { 
        ...product, 
        quantity: product.quantity || 1,
        // Ensure variant image is used if available, otherwise use main product image
        image: product.variantImage || product.image,
        addedAt: new Date().toISOString() 
      }];
    });
  };

  const removeFromCart = (cartKey) => {
    setCart(prev => prev.filter((item, index) => {
      const itemKey = item.variantId && item.variantId !== 'standard'
        ? `${item.id}_${item.variantId}` 
        : `${item.id}_standard`;
      return itemKey !== cartKey && index.toString() !== cartKey;
    }));
  };

  const updateQuantity = (cartKey, quantity) => {
    if (quantity < 1) {
      removeFromCart(cartKey);
      return;
    }
    setCart(prev => prev.map((item, index) => {
      const itemKey = item.variantId && item.variantId !== 'standard'
        ? `${item.id}_${item.variantId}` 
        : `${item.id}_standard`;
      if (itemKey === cartKey || index.toString() === cartKey) {
        return { ...item, quantity };
      }
      return item;
    }));
  };

  const clearCart = () => setCart([]);

  const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);
  const totalPrice = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);

  return (
    <CartContext.Provider value={{
      cart, 
      addToCart, 
      removeFromCart, 
      updateQuantity, 
      clearCart,
      totalItems, 
      totalPrice
    }}>
      {children}
    </CartContext.Provider>
  );
};